import { getExperimentParticipationQueryKey } from '@data/queries/experiment/getExperimentQueryKey'
import { getQueryClient } from '@data/queries/queryClient'

/**
 * Determines if the user is allowed to view this route, given their experiment participation.
 *
 * Returns `true` (user is allowed to navigate) if the route is not guarded by an experiments.
 *
 * Returns `false` (user must do a full page reload to navigate) if we haven't yet fetched their experiment
 * participation.
 */
export function isExperimentSatisfied(route: TRoute): boolean {
    if (!route.definition.experiments?.allowSpaNav) {
        return true
    }

    const { name, segments } = route.definition.experiments.allowSpaNav
    const data = getQueryClient().getQueryData<TExperimentMap>(getExperimentParticipationQueryKey(name))
    const cachedSegment = data ? data[name] : undefined

    if (!cachedSegment) {
        return false
    }

    return segments.includes(cachedSegment)
}
